import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {useParams} from 'react-router-dom';
import {TasksSingleVoyagesLazy} from "@containers/singleVoyage/tasks/TasksSingleVoyages.lazy";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {
    useGetInitialAccountIdSingleVoyage
} from "@containers/singleVoyage/account/hooks/useGetInitialAccountIdSingleVoyage";

const TasksSingleVoyagePage = () => {
    const {voyageId} = useParams()
    const initialAccountId = useGetInitialAccountIdSingleVoyage()
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <TasksSingleVoyagesLazy
                    voyageId={Number(voyageId)}
                    accountId={initialAccountId}
                />
            </Suspense>
        </PageLayout>
    );
};

export default TasksSingleVoyagePage;
